import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Header from "../components/header";
import Footer from "../components/footer";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Use shared Header */}
      <Header />

      {/* Main Content */}
      <Box sx={{ p: 4, backgroundColor: "#f5f7fa", minHeight: "80vh" }}>
        <Paper
          elevation={6}
          sx={{
            p: 5,
            maxWidth: "900px",
            margin: "0 auto",
            borderRadius: "16px",
            backgroundColor: "#ffffff",
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#4285f4" }}
          >
            Privacy Policy
          </Typography>

          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ fontStyle: "italic", color: "#616161" }}
          >
            Effective Date: 8-1-25 | Last Updated: 8-27-25
          </Typography>

          <Typography paragraph sx={{ mb: 3, color: "#424242" }}>
            This Privacy Policy explains how Autoshops.com (“we”, “our”, or “us”)
            collects, uses, and protects your personal information.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            1. Information We Collect
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            • <b>User-Provided:</b> Name, email, phone number, vehicle
            information, diagnostic codes, and service history. <br />
            • <b>Automatic:</b> IP address, browser type, usage data, location
            (with permission), and cookies.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            2. How We Use Information
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            • Provide and improve our services. <br />
            • Match users with relevant auto shops. <br />
            • Send service updates, reminders, and promotions. <br />
            • Analyze trends and platform usage. <br />
            • Enforce terms and prevent fraud.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            3. Information Sharing
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            We do not sell your personal information. We may share your data
            with: <br />
            - Partner auto shops (when you submit a request). <br />
            - Service providers (e.g., cloud storage, analytics). <br />
            - Authorities, if required by law.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            4. Cookies & Tracking
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            We use cookies to enhance your experience. You can adjust cookie
            preferences in your browser.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            5. Data Security
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            We implement industry-standard security to protect your data,
            including encryption and access controls. However, no system is 100%
            secure.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            6. Your Choices
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            You may access, correct, or delete your data at any time via your
            account. You may also opt out of marketing emails via unsubscribe
            links.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            7. Children’s Privacy
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            Our services are not intended for users under 13. We do not
            knowingly collect personal data from children.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            8. Third-Party Links
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            Our site may contain links to other websites. We are not responsible
            for their content or privacy practices.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            9. Data Retention
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            We retain data as long as your account is active or as needed to
            comply with legal obligations.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: "#4285f4" }}>
            10. Contact Us
          </Typography>
          <Typography paragraph sx={{ color: "#424242" }}>
            If you have questions, contact us at: <br />
            <b>Email:</b> info@autoshops.com <br />
            <b>Address:</b> Autoshops.com, Orlando, FL
          </Typography>
        </Paper>
      </Box>

      {/* Use shared Footer */}
      <Footer />
    </>
  );
};


export default PrivacyPolicy;
